import {signal} from "@preact/signals"

export const allUsersSignal = signal(null)